import { ApiPaginationRequestDto } from '../../base-dtos';

export interface NewsCommentsRequestDto extends ApiPaginationRequestDto {
  order?: NewsCommentOrderKey | null;
}

export type NewsCommentOrderKey = 'publicationDate' | '-publicationDate';
